import { Button, Card, message } from 'antd';
import { QUOTE_STATUSES } from '../../constants/QuoteStatuses';
import { disabledByAnotherAction, recordHasContractorId } from '../../utils/DataAccessUtils';
import * as React from 'react';

export const PublishQuoteBanner = ({
	setActionButtonLoading,
	actionButtonLoading,
	markPendingQuote,
	quote,
	refresh,
}) => {
	const isContractorQuote = recordHasContractorId(quote);

	const handleMarkPendingQuote = (quote) => {
		message.open({
			key: 'quoteDetailMessageUpdating',
			type: 'loading',
			content: 'Publishing...',
			duration: 60,
		});
		setActionButtonLoading(QUOTE_STATUSES.pending);
		markPendingQuote(quote, isContractorQuote)
			.then((resultQuote) => {
				message.destroy('quoteDetailMessageUpdating');
				message.success('Published!');
				refresh();
			})
			.finally(() => {
				setActionButtonLoading(null);
			});
	};

	return (
		<div className="rowSpacing flex w-full">
			<Card
				style={{ border: '1px solid #8ed7eb' }}
				bodyStyle={{
					padding: '16px 24px',
					background: '#ebfbff',
				}}
				className={'w-full'}
			>
				<div>
					<h5 style={{ marginBottom: '4px' }}>Publish quote?</h5>
					<div>
						<p
							style={{
								fontSize: 16,
								marginBottom: '0.5em',
							}}
						>
							This quote is still a draft and isn't visible to the customer yet.
						</p>
						<Button
							type="primary"
							key="approve"
							loading={actionButtonLoading === QUOTE_STATUSES.pending}
							disabled={disabledByAnotherAction(actionButtonLoading, QUOTE_STATUSES.pending)}
							onClick={() => handleMarkPendingQuote(quote)}
						>
							Publish quote
						</Button>
					</div>
				</div>
			</Card>
		</div>
	);
};
